import { render, staticRenderFns } from "./PropertyPinTagsList.vue?vue&type=template&id=1a1c2fe6&scoped=true&"
import script from "./PropertyPinTagsList.vue?vue&type=script&lang=js&"
export * from "./PropertyPinTagsList.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPinTagsList.vue?vue&type=style&index=0&id=1a1c2fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c2fe6",
  null
  
)

export default component.exports